/**
 * Message types for SignalR messages between the client and server.
 */
export enum SignalrMessageTypes {
    ValidationComplete = "ValidationComplete"
}